// extracted by mini-css-extract-plugin
export default {"mobileNav":"MobileNav_mobileNav__v2zMa","navItem":"MobileNav_navItem__LE-sG","navItemActive":"MobileNav_navItemActive__M4icF","navItemText":"MobileNav_navItemText__d6NRh"};